import React from 'react'

import noArchivedThreads from 'assets/images/no-archived-threads.svg'

export default function ArchivedThreadsPlaceholder() {
  return (
    <div className="flexbox flexbox-column flexbox-grow flexbox-align-center padding-horizontal-large">
      <img
        style={{ width: '100%' }}
        className="margin-top-large margin-bottom-large"
        src={noArchivedThreads}
        alt="No threads"
      />
      <div className="font-weight-bold shade-10 margin-bottom-normal">
        No resolved thread
      </div>
      <div className="shade-10 margin-bottom-normal">
        You can click on “resolve” once a thread is over
      </div>
    </div>
  )
}
